import { useState, useEffect } from 'react';

import BaseLayout from '@lcsc-ui/layouts/baseLayout';
import ecpCurl from '@lcsc-ui/utils/ecpCurl';
import Utils from '@lcsc-ui/utils/Utils';
import { Breadcrumb } from 'antd';
import { NextSeo } from 'next-seo';

import OpApi from '@/apis/op';
import StaticdataApi from '@/apis/staticdata';
import { SERVICE_AGREEMENT_HTML } from '@/constants/serviceAgreement';
import HelpMainMenu from '@/features/mrohelp/HelpMainMenu';

const metadata = {
  title: '立创商城用户协议 - 立创商城',
  description: '立创商城用户协议，详细说明用户权利与义务、服务条款、隐私保护等内容。',
  additionalMetaTags: [
    { name: 'keywords', content: '立创商城用户协议,服务条款,用户权益,隐私保护' },
    { name: 'author', content: '立创商城' },
  ],
};

export default function Service({ resourceData, websiteSectionList, catalogList, headerAd }) {
  return (
    <>
      <NextSeo {...metadata} />
      <style jsx global>{`
        .help-content p {
          color: #444;
          line-height: 30px;
          font-size: 14px;
        }
        .help-content span {
          line-height: 30px;
          font-size: 14px;
        }
        .help-content a {
          color: #0093e6;
          text-decoration: none;
        }
        .help-content a:hover {
          text-decoration: underline;
        }
      `}</style>
      <BaseLayout
        resourceData={resourceData}
        websiteSectionList={websiteSectionList}
        catalogList={catalogList}
        headerAd={headerAd}
        isLgScreen={false}
        notIndexHeaderAdapter={true}
        onlySScreen={true}
      >
        <section className="w-[1200px] mx-auto py-[16px]">
          <Breadcrumb separator=">" items={[{ title: '首页' }, { title: '帮助中心' }]} />
          <section className="flex gap-4 mt-[16px]">
            <HelpMainMenu />
            <main className="flex-1 p-[40px] pt-[20px] pb-[68px] bg-white rounded-[20px]">
              <div className="leading-[64px] text-[#ccc] text-[30px] border-b border-solid border-[#e9e9e9]">
                立创商城用户协议
              </div>
              <div className="help-content" dangerouslySetInnerHTML={{ __html: SERVICE_AGREEMENT_HTML }} />
            </main>
          </section>
        </section>
      </BaseLayout>
    </>
  );
}

export async function getServerSideProps(context) {
  const { req } = context;

  const [websiteSectionList, resourceData, catalogList, headerAd] = await Promise.all([
    ecpCurl(OpApi.websiteSection, { headers: req.headers }),
    ecpCurl(StaticdataApi.resourceList, { headers: req.headers }),
    ecpCurl(StaticdataApi.catalogList, { headers: req.headers }),
    ecpCurl(OpApi.advertisingHeader),
  ]);

  return {
    props: {
      resourceData,
      websiteSectionList,
      catalogList,
      headerAd,
    },
  };
}
